import ReactDOM from "react-dom";

export function focusInvalidField(errors, component, form) {
  const node = ReactDOM.findDOMNode(component);
  if (!node) return;

  const err = errors.errors;
  const keys = Object.keys(err);
  if (keys.length > 0) {
    const f = node.querySelector(`form[name=${form}]`);
    if (!f) return;
    const el = f.querySelector(`[name=${err[keys[0]][0].prop}]`);
    if (!el) return;
    el.focus();
    return;
  }
}

export function addNotificationsForInvalidFields(
  errors,
  notificationSystem,
  fields = false
) {
  const err = errors.errors;
  let notification = {
    level: "error",
    position: "br",
    autoDismiss: 5,
    dismissible: true
  };

  Object.keys(err).forEach(key => {
    err[key].forEach(error => {
      if (error.showError && fields || !fields && key === "all") {
        notification.message = error.msg;
        notificationSystem.addNotification(notification);
      }
    });
    return;
  });
}



// WEBPACK FOOTER //
// ./src/browser/lib/validationWeb.js